import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

const NavLink = ({
  to,
  label,
  breakLine = false,
  condition = true,
  permission = true,
  external = false,
  children,
  ...props
}) => {
  if (!condition || !permission) {
    return null;
  }

  if (breakLine) {
    return <br />;
  }

  if (external) {
    return (
      <div>
        <a href={to} {...props} rel="noopener noreferrer">
          {label || children}
        </a>
      </div>
    );
  }

  return (
    <div>
      <RouterLink exact to={to} {...props}>
        {label || children}
      </RouterLink>
    </div>
  );
};

export default NavLink;
